import { useEffect, useRef } from "react"
import useClickOutside from "../../hooks/useClickOutside"
import "./modal.component.css"
import { gsap } from "gsap"

const ModalComponent = (props) => {
  const { title, content, actions, onClose } = props
  const ref = useRef()
  useClickOutside(ref, onClose)

  useEffect(() => {
    gsap.fromTo(
      ".cb-modal",
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 0.4,
      }
    )

    gsap.fromTo(
      ".cb-modal-content",
      {
        opacity: 0,
        scale: 0.9,
      },
      {
        opacity: 1,
        scale: 1,
        duration: 0.4,
        delay: 0.1,
        ease: "power3.inOut",
      }
    )
  }, [])

  return (
    <div className="cb-modal">
      <div className="cb-modal-content" ref={ref}>
        <div className="cb-modal-header">
          <h3>{title}</h3>
        </div>
        <div className="cb-modal-children">{content}</div>
        <div className="cb-modal-footer">{actions}</div>
      </div>
    </div>
  )
}

export default ModalComponent
